import React, { useContext, useEffect, useRef, useState } from "react";
import bannerloginimage from "../../Images/bannerloginimage.png";
import { Colorcontext } from "../../Component/Colorcontext/ColorContext";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
// import Workprogressbar from "../SearchHome/Workprogressbar";
import "./Style.css"
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import SkeletonSignupForm from "../../View/SearchHome/skeletons/SkeletonSignupForm";
import NumberCaptchaV2 from "../../View/BusinessListing/components/NumberCaptchaV2";
import SeoGeneral from '../BusinessPage/SeoGeneral';
import LeftInfoPanel from "./LeftInfoPanel";

const CardMemberRegistration = () => {
  const { UserProfileID } = useSelector((state) => state.app);
  const navigate = useNavigate();
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const { choosePlanID } = location.state || {};
  const [selectedPlan, setSelectedPlan] = useState({ _id: "", name: "" });

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyPassword, setShowVerifyPassword] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [formError, setFormError] = useState({
    usernameError: "",
    passwordError: "",
    checkboxError: "",
    captchaError: "",
  });

  const [validation, setValidation] = useState({
    lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
    minLength: false,
  });
  const [showLoader, setShowLoader] = useState(false);
  const captchaRef = useRef();

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    setValidation({
      lowercase: /[a-z]/.test(value),
      uppercase: /[A-Z]/.test(value),
      number: /\d/.test(value),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
      minLength: value.length >= 8,
    });
  };

  const getPlan = async () => {
    setLoading(true);
    const res = await HttpClient.requestData("subscription-plans", "GET", "");
    if (res && res.status) {
      setPlans(res?.data.reverse());
    } else {
      console.log("Error from getting subscription:", res);
    }
    setLoading(false);
  };

  const choosedPlan = () => {
    if (plans.length === 0 || !choosePlanID) return;
    const selected = plans.find((item) => item._id === choosePlanID);
    if (selected) {
      setSelectedPlan({ _id: selected._id, name: selected.plan });
    }
  };

  useEffect(() => {
    if (UserProfileID) {
      navigate(`/profile/${UserProfileID?.userName}`)
    }
    getPlan();
  }, []);

  useEffect(() => {
    choosedPlan();
  }, [plans, choosePlanID]);

  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, [colordata]);

  const validateForm = () => {
    let isValid = true;
    // Validate username (ensure it's a valid email)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (username.trim() === "") {
      setFormError((prevState) => ({
        ...prevState,
        usernameError: "Username is required.",
      }));
      isValid = false;
    } else if (!emailRegex.test(username)) {
      setFormError((prevState) => ({
        ...prevState,
        usernameError: "Please enter a valid email address.",
      }));
      isValid = false;
    } else {
      setFormError((prevState) => ({ ...prevState, usernameError: "" }));
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,16}$/;
    if (password.trim() === "") {
      setFormError((prevState) => ({
        ...prevState,
        passwordError: "Password is required.",
      }));
      isValid = false;
    } else if (!passwordRegex.test(password)) {
      setFormError((prevState) => ({
        ...prevState,
        passwordError:
          "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.",
      }));
      isValid = false;
    } else {
      setFormError((prevState) => ({ ...prevState, passwordError: "" }));
    }

    // Validate checkbox
    if (!isChecked) {
      setFormError((prevState) => ({
        ...prevState,
        checkboxError: "You must agree to the terms and privacy policy.",
      }));
      isValid = false;
    } else {
      setFormError((prevState) => ({ ...prevState, checkboxError: "" }));
    }

    // Validate captcha
    const isNumCaptchValid = captchaRef.current.validate();
    if (!isNumCaptchValid) {
      setFormError((prevState) => ({
        ...prevState,
        captchaError: "Incorrect captcha answer.",
      }));
      isValid = false;
    } else {
      setFormError((prevState) => ({ ...prevState, captchaError: "" }));
    }

    return isValid;
  };

  // const reSendOTP = async () => {
  //   const data = {
  //     emailId: username,
  //   };
  //   const res = await HttpClient.requestData("neoo-member", "POST", data);
  //   try {
  //     setFormError((prevState) => ({ ...prevState, otpError: "" }));
  //     inputsRef.current.forEach(input => input && (input.value = ''));
  //     inputsRef.current = [];
  //   } catch (error) {

  //   }
  // }

  ///////////Sending OTP in the email address///////////
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (verifyPassword !== password) {
      toast.error("Confirm password mismatch!")
      return
    }

    if (validateForm()) {
      const data = {
        emailId: username,
        password: password
      };
      setShowLoader(true);
      const res = await HttpClient.requestData("neoo-member", "POST", data);
      setShowLoader(false);
      if (res?.status) {
        if (res?.data?.otpVerifyStatus && res?.status) {
          // Move to Enter Personal Details page
          navigate("/create-businesscard-details", {
            state: {
              username: username,
              password: password,

              profileTypeID: res?.data?.profileTypeID || "",
              userName: res?.data?.userName || "",
              personName: res?.data?.personName || "",
              designationID: res?.data?.designationID || "",
              phone_code: res?.data?.phone_code || "+971",
              countryCodePhone: res?.data?.phone_code || "+971",
              telephoneNo: res?.data?.telephoneNo || "",
              countryCodeMobile: res?.data?.phone_code || "+971",
              mobileNo: res?.data?.mobileNo || "",
              emirate: res?.data?.emirate || "",
              country: res?.data?.country || "65f95f070d6753c3bdacccd9",
              companyName: res?.data?.companyName || "",
              companyTypeID: res?.data?.companyTypeID || "",
              websiteLink: res?.data?.websiteLink || "",
              emailId: username,
            },
          });
        } else if (!res?.data?.otpVerifyStatus) {
          // Open the OTP input box for verification
          setShowOTPBlock(!showOTPBlock);
        } else {
          setFormError((prevState) => ({
            ...prevState,
            usernameError: "Email already exist, Please try with another email.",
          }));
        }

      } else {
        setFormError((prevState) => ({
          ...prevState,
          usernameError: "A user with this email address already exist.",
        }));
      }
      setShowLoader(false);
    } else {
      console.log("Form validation failed.");
    }
  };

  ////////////////////////Card Member//////////////////////////
  const [showOTPBlock, setShowOTPBlock] = useState(false)
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (value.length > 1) return;

    if (value && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const getInputValues = () => {
    return inputsRef.current.map(input => input?.value || '').join('');
  };

  const handleOTPVerification = async (e) => {
    e.preventDefault()
    try {
      const data = {
        emailId: username,
        otp: getInputValues(),
      };
      const res = await HttpClient.requestData("verify-otp", "POST", data);
      if (res.status) {
        navigate("/create-businesscard-details", {
          state: { username: username, password: password },
        });
      } else {
        setFormError((prevState) => ({
          ...prevState,
          otpError: "Invalid OTP",
        }));
      }
    } catch (error) {

    }
  }

  const seoMetaData = {
    title: "NeooSearch – Create Your NeooCard Free for Life",
    description: "Create your free digital business card on NeooSearch with QR code, social links, and exchange your contact information to Smartly connect with customers and grow your network.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "NeooSearch – Create Your NeooCard Free for Life",
    url: process.env.REACT_APP_APPLICATION_URL + "/free-digital-business-card",
    keywords: "NeooSearch, business card, digital business card, QR code, social links, contact information exchange",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/free-digital-business-card"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      {
        !showOTPBlock ? (
          <>
            <section className="reg-container">
              <div className="cust_container">
                <div className="Searchloginformmainbg">
                  <div className="reg-left-box">
                    <LeftInfoPanel />
                  </div>
                  <div class="reg-divider"></div>
                  <div className="reg-right-box">
                    {showLoader ? (<SkeletonSignupForm />) : (
                      <div className="Searchloginformmainrightbg">
                        <p className="creattusettxpp">Get Started Free<br /><span style={{ fontSize: "80%", fontWeight: "normal" }}>Already have an account? <Link to="/user-login">Login</Link></span></p>

                        <div className="usenametxttppmian">
                          <p className="usenametxttpp">User name</p>
                          <input
                            type="text"
                            placeholder="username@gmail.com"
                            className="usenametxttppinput"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                        {formError.usernameError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.usernameError}
                          </p>
                        )}

                        <div className="usenametxttppmian">
                          <p className="usenametxttpp">Password</p>
                          <div className="usenametpasswrdifv">
                            <input
                              type={showPassword ? "text" : "password"}
                              placeholder="Password"
                              className="usenametxttppinput"
                              value={password}
                              onChange={handlePasswordChange}
                            />

                            <div
                              className="showiconnimg"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`fa-regular ${showPassword ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              ></i>
                            </div>
                            <div className="passowrdrestritiondiv" style={{ zIndex: "999" }}>
                              <div className="passowrdrestritiondivtop">
                                <p className="minimumpasswodttrxpp">
                                  The minimum password length is 8 characters and must
                                  contain at least 1 lowercase letter, 1 capital letter, 1
                                  number, and 1 special character.
                                </p>
                              </div>
                              <div className="passowrdrestritiondivbottom">
                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.minLength ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.minLength && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Minimum 8 characters
                                  </label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.lowercase ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.lowercase && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Lowercase letter
                                  </label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.uppercase ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.uppercase && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Capital letter
                                  </label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.number ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.number && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">Number</label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.specialChar ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.specialChar && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Special character
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="usenametxttppmian">
                          <p className="usenametxttpp">Verify Password</p>
                          <div className="usenametpasswrdifv">
                            <input
                              type={showVerifyPassword ? "text" : "password"}
                              placeholder="Password"
                              className="usenametxttppinput"
                              value={verifyPassword}
                              onChange={(e) => setVerifyPassword(e.target.value)}
                            />

                            <div
                              className="showiconnimg"
                              onClick={() => setShowVerifyPassword(!showVerifyPassword)}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`fa-regular ${showVerifyPassword ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              ></i>
                            </div>
                          </div>
                        </div>

                        {formError.passwordError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.passwordError}
                          </p>
                        )}

                        <div className="agereecheck">
                          <input
                            type="checkbox"
                            className="schekbdttstxttpp"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                          />
                          <p className="agreerxtppptt">
                            I agree with the <span>Terms of services</span> and{" "}
                            <span>Privacy Policy</span>
                          </p>
                        </div>
                        {formError.checkboxError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.checkboxError}
                          </p>
                        )}

                        <div className="addedasldibv">

                          <NumberCaptchaV2 ref={captchaRef} />
                        </div>
                        {formError.captchaError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.captchaError}
                          </p>
                        )}

                        <div className="btnnexttdivbtnmain">
                          <button className="btnnexttdivbtn" onClick={(e) => handleSubmit(e)}>
                            Create NeooCard
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>
            </section>
            {/* <section className="Searchloginformmain">
              <div className="cust_container">
                <div className="Searchloginformmainbg">
                  <div className="Searchloginformmainleft">
                    <div className="Searchloginformmainleftimg">
                      <LeftInfoPanel />
                    </div>
                  </div>
                  {showLoader ? (<SkeletonSignupForm />) : (
                    <div className="Searchloginformmainright">
                      <div className="Searchloginformmainrightbg">
                        <p className="creattusettxpp">Get Started Free<br /><span style={{ fontSize: "80%", fontWeight: "normal" }}>Already have an account? <Link to="/user-login">Login</Link></span></p>

                        <div className="usenametxttppmian">
                          <p className="usenametxttpp">User name</p>
                          <input
                            type="text"
                            placeholder="username@gmail.com"
                            className="usenametxttppinput"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                        {formError.usernameError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.usernameError}
                          </p>
                        )}

                        <div className="usenametxttppmian">
                          <p className="usenametxttpp">Password</p>
                          <div className="usenametpasswrdifv">
                            <input
                              type={showPassword ? "text" : "password"}
                              placeholder="Password"
                              className="usenametxttppinput"
                              value={password}
                              onChange={handlePasswordChange}
                            />

                            <div
                              className="showiconnimg"
                              onClick={() => setShowPassword(!showPassword)} 
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`fa-regular ${showPassword ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              ></i>
                            </div>
                            <div className="passowrdrestritiondiv" style={{ zIndex: "999" }}>
                              <div className="passowrdrestritiondivtop">
                                <p className="minimumpasswodttrxpp">
                                  The minimum password length is 8 characters and must
                                  contain at least 1 lowercase letter, 1 capital letter, 1
                                  number, and 1 special character.
                                </p>
                              </div>
                              <div className="passowrdrestritiondivbottom">
                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.minLength ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.minLength && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Minimum 8 characters
                                  </label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.lowercase ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.lowercase && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Lowercase letter
                                  </label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.uppercase ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.uppercase && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Capital letter
                                  </label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.number ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.number && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">Number</label>
                                </div>

                                <div className="radionattstxtdibflx">
                                  <div
                                    className={`radiobacustomdesign ${validation.specialChar ? "tick-green" : ""
                                      }`}
                                  >
                                    {validation.specialChar && (
                                      <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                      ></i>
                                    )}
                                  </div>
                                  <label className="radiobtntxtxtplalbel">
                                    Special character
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="usenametxttppmian">
                          <p className="usenametxttpp">Verify Password</p>
                          <div className="usenametpasswrdifv">
                            <input
                              type={showVerifyPassword ? "text" : "password"} 
                              placeholder="Password"
                              className="usenametxttppinput"
                              value={verifyPassword}
                              onChange={(e) => setVerifyPassword(e.target.value)}
                            />

                            <div
                              className="showiconnimg"
                              onClick={() => setShowVerifyPassword(!showVerifyPassword)}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`fa-regular ${showVerifyPassword ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              ></i>
                            </div>
                          </div>
                        </div>

                        {formError.passwordError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.passwordError}
                          </p>
                        )}

                        <div className="agereecheck">
                          <input
                            type="checkbox"
                            className="schekbdttstxttpp"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                          />
                          <p className="agreerxtppptt">
                            I agree with the <span>Terms of services</span> and{" "}
                            <span>Privacy Policy</span>
                          </p>
                        </div>
                        {formError.checkboxError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.checkboxError}
                          </p>
                        )}

                        <div className="addedasldibv">
                       
                          <NumberCaptchaV2 ref={captchaRef} />
                        </div>
                        {formError.captchaError && (
                          <p
                            className="error-message"
                            style={{
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            {formError.captchaError}
                          </p>
                        )}

                        <div className="btnnexttdivbtnmain">
                          <button className="btnnexttdivbtn" onClick={(e) => handleSubmit(e)}>
                            Create NeooCard
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section> */}
          </>
        ) : (
          <>
            {/* <section className="Searchloginformmain">
              <div className="cust_container">
                <div className="Searchloginformmainbg">
                  <div className="Searchloginformmainleft">
                    <div className="Searchloginformmainleftimg">
                      <img src={bannerloginimage} alt="banner" />
                    </div>
                  </div>

                  <div className="Searchloginformmainright" style={{ textAlign: 'center' }}>
                    <div className="Searchloginformmainrightbg">
                      <h2 className="_creattusettxpp mb-4" style={{ textAlign: 'center' }}>OTP Verification</h2>
                      <p>Enter the OTP sent to {username}</p>

                      <div>
                        <div className="otp-container">
                          {[...Array(4)].map((_, i) => (
                            <input
                              key={i}
                              type="text"
                              maxLength={1}
                              className="otp-input"
                              ref={(el) => (inputsRef.current[i] = el)}
                              onChange={(e) => handleChange(e, i)}
                              onKeyDown={(e) => handleKeyDown(e, i)}
                            />
                          ))}
                        </div>
                      </div>


                      {formError.otpError && (
                        <p
                          className="error-message"
                          style={{
                            color: "red",
                            fontSize: "12px",
                          }}
                        >
                          {formError.otpError}
                        </p>
                      )}
                      <button className="btnnexttdivbtn mt-5" onClick={handleOTPVerification}>
                        Verify
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}


            <section className="reg-container">
              <div className="cust_container">
                <div className="Searchloginformmainbg">
                  <div className="reg-left-box">
                    <LeftInfoPanel />
                  </div>
                  <div class="reg-divider"></div>
                  <div className="reg-right-box" style={{ textAlign: 'center' }}>
                    <div className="Searchloginformmainrightbg">
                      <h2 className="_creattusettxpp mb-4" style={{ textAlign: 'center' }}>OTP Verification</h2>
                      <p>Enter the OTP sent to {username}</p>

                      <div>
                        <div className="otp-container">
                          {[...Array(4)].map((_, i) => (
                            <input
                              key={i}
                              type="text"
                              maxLength={1}
                              className="otp-input"
                              ref={(el) => (inputsRef.current[i] = el)}
                              onChange={(e) => handleChange(e, i)}
                              onKeyDown={(e) => handleKeyDown(e, i)}
                            />
                          ))}
                        </div>
                      </div>


                      {formError.otpError && (
                        <p
                          className="error-message"
                          style={{
                            color: "red",
                            fontSize: "12px",
                          }}
                        >
                          {formError.otpError}
                        </p>
                      )}
                      <button className="btnnexttdivbtn mt-5" onClick={handleOTPVerification}>
                        Verify
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

          </>
        )

      }


    </>

  );
};

export default CardMemberRegistration;
